import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './styles.css';

// Service Worker auto-registrato da vite-plugin-pwa (registerType: 'autoUpdate').
// L'import qui sotto carica solo l'helper di registrazione — viene tree-shaken in dev.
// In dev (devOptions.enabled: false) la registrazione è inattiva, quindi questo è no-op.
import { registerSW } from 'virtual:pwa-register';

if (typeof window !== 'undefined') {
  registerSW({
    immediate: true,
    onRegisteredSW(swUrl) {
      // eslint-disable-next-line no-console
      console.log('[PWA] Service Worker registrato:', swUrl);
    },
    onOfflineReady() {
      // eslint-disable-next-line no-console
      console.log('[PWA] Pronta per uso offline');
    },
    onNeedRefresh() {
      // eslint-disable-next-line no-console
      console.log('[PWA] Nuova versione disponibile — verrà applicata al prossimo riavvio');
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
